// Global 
function updateBodyClass() {
    const width = window.innerWidth;
    const body = document.body;

    // Remove existing classes
    body.classList.remove('is-desktop', 'is-tablet', 'is-mobile');

    // Add class based on current width
    if (width >= 1025) {
        body.classList.add('is-desktop');
    } else if (width >= 768 && width < 1025) {
        body.classList.add('is-tablet');
    } else {
        body.classList.add('is-mobile');
    }
}

// Initial run
updateBodyClass();

// Update on resize
window.addEventListener('resize', updateBodyClass);

// /* Browser Check */
function addBrowserClass() {
    const body = document.body;
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edge') === -1) {
        body.classList.add('browser-chrome');
    } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
        body.classList.add('browser-safari');
    } else if (userAgent.indexOf('firefox') > -1) {
        body.classList.add('browser-firefox');
    } else if (userAgent.indexOf('edge') > -1) {
        body.classList.add('browser-edge');
    } else {
        body.classList.add('browser-unknown');
    }
}

addBrowserClass();

// kiks Product comparison section 
(function () {
    const MOBILE_WIDTH = 430;
    let isStickyApplied = false;

    function isMobile() {
        return window.innerWidth <= MOBILE_WIDTH;
    }

    function getStickySpans() {
        return document.querySelectorAll('.feature-label span.product-comparison-grid__sticky');
    }

    function applyStickyEffect(wrapper) {
        const rows = document.querySelectorAll('.comparison-scroll-wrapper .row');
        if (!rows.length) return;

        const handleScroll = () => {
            const scrollLeft = wrapper.scrollLeft;
            rows.forEach(row => {
                const stickySpan = row.querySelector('.feature-label span.product-comparison-grid__sticky');
                if (stickySpan) {
                    Object.assign(stickySpan.style, {
                        transform: `translateX(${scrollLeft}px)`,
                        position: 'relative',
                        zIndex: '10',
                        display: 'inline-block',
                        willChange: 'transform'
                    });
                }
            });
        };

        wrapper.addEventListener('scroll', handleScroll);
        wrapper._stickyScrollHandler = handleScroll;
        handleScroll(); // initial scroll effect
        isStickyApplied = true;
    }

    function removeStickyEffect(wrapper) {
        const spans = getStickySpans();
        spans.forEach(span => {
            Object.assign(span.style, {
                transform: '',
                position: '',
                zIndex: '',
                display: '',
                willChange: ''
            });
        });

        if (wrapper._stickyScrollHandler) {
            wrapper.removeEventListener('scroll', wrapper._stickyScrollHandler);
            delete wrapper._stickyScrollHandler;
        }

        isStickyApplied = false;
    }

    function handleResizeOrInit() {
        const wrapper = document.querySelector('.comparison-scroll-wrapper');
        if (!wrapper) return;

        if (isMobile() && !isStickyApplied) {
            applyStickyEffect(wrapper);
        } else if (!isMobile() && isStickyApplied) {
            removeStickyEffect(wrapper);
        }
    }

    window.addEventListener('DOMContentLoaded', handleResizeOrInit);
    window.addEventListener('resize', handleResizeOrInit);
})();

import(flu.chunks.swiper).then(({ Swiper, Navigation, Pagination, Thumbs, FreeMode }) => {
    // TabSlider Start Here
    // Swiper Tab
    const swiperTab = new Swiper(".sliderTab", {
        slidesPerView: "auto",
        spaceBetween: 24,
        freeMode: true,
        modules: [Navigation, Pagination, Thumbs, FreeMode],
        navigation: {
            nextEl: ".sliderTab__next",
            prevEl: ".sliderTab__prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            480: {
                slidesPerView: 1.5,
                spaceBetween: 24,
            },
            768: {
                slidesPerView: "auto",
                spaceBetween: 24,
            },
            980: {
                slidesPerView: "auto",
                spaceBetween: 24,
            },
            1280: {
                slidesPerView: "auto",
                spaceBetween: 24,
            }
        },
    });

    const $lankTitle = $(".sliderTab .swiper-slide button");

    $lankTitle.click(function () {
        const target = $(this).parent(); // .swiper-slide
        const index = target.index();

        $lankTitle.parent().removeClass("on");
        target.addClass("on");

        swiperTab.slideTo(index, 500); // This handles the centering!
        swiperContent.slideTo(index);
    });


    // function muCenter(target) {
    //     const snbwrap = $(".sliderTab .swiper-wrapper");
    //     const targetPos = target.position();
    //     const boxWidth = $(".sliderTab").width();
    //     let wrapWidth = 0;

    //     snbwrap.find(".swiper-slide").each(function () {
    //         wrapWidth += $(this).outerWidth();
    //     });

    //     const selectTargetPos = targetPos.left + target.outerWidth() / 2;
    //     let pos;
    //     if (selectTargetPos <= boxWidth / 2) {
    //         pos = 0;
    //         $(".sliderTab__prev").addClass("swiper-button-disabled");
    //     } else if (wrapWidth - selectTargetPos <= boxWidth / 2) {
    //         pos = wrapWidth - boxWidth;
    //         $(".sliderTab__next").addClass("swiper-button-disabled");
    //     } else {
    //         pos = targetPos.left - boxWidth / 2 + target.outerWidth() / 2;
    //         $(".sliderTab__prev, .sliderTab__next").removeClass("swiper-button-disabled");
    //     }

    //     if (wrapWidth > boxWidth) {
    //         setTimeout(function () {
    //             snbwrap.css({
    //                 transform: "translate3d(" + pos * -1 + "px, 0, 0)",
    //                 "transition-duration": "500ms",
    //             });
    //         }, 200);
    //     }
    // }


    // Swiper Content
    const swiperContent = new Swiper(".sliderContent", {
        slidesPerView: 1,
        allowTouchMove: true,
        grabCursor: true,
        modules: [Thumbs],
        thumbs: {
            swiper: swiperTab,
        },
    });
    // 👉 Add this block next:
    swiperContent.on('slideChange', function () {
        const index = swiperContent.activeIndex;

        $lankTitle.parent().removeClass("on");
        $lankTitle.eq(index).parent().addClass("on");

        swiperTab.slideTo(index);
    });
    // TabSlider End Here

    // Product Gallery Slider
    // const productGallerySlider = new Swiper('.product-gallery-slider', {
    //     slidesPerView: 1,
    //     modules: [Navigation, Pagination, Thumbs, FreeMode],
    //     // Navigation arrows
    //     // navigation: {
    //     //     nextEl: '.swiper-button-next',
    //     //     prevEl: '.swiper-button-prev',
    //     // },
    //     pagination: {
    //         el: '.swiper-pagination', // <- Must match your HTML element
    //         clickable: true,
    //     },
    // });
});
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(
        ".product-gallery-slider .swiper-button-next, .product-gallery-slider .swiper-button-prev, .product-gallery-slider .swiper-pagination span.swiper-pagination-bullet"
    );

    const removeHidden = () => {
        document.querySelectorAll(
            ".product-gallery-slider .swiper-slide.hidden"
        ).forEach(el => el.classList.remove("hidden"));
    };

    buttons.forEach(btn => {
        btn.addEventListener("click", () => {
            // console.log("REMOVE");
            setTimeout(removeHidden, 50); // Allow Swiper to update DOM first
        });
    });
});

// megamenu code on safari
if (document.body.classList.contains('browser-safari')) {
    document.querySelectorAll('[data-meganav-trigger]').forEach(trigger => {
        trigger.addEventListener('click', function () {
            const handle = trigger.dataset.meganavHandle;
            const menu = document.querySelector(`.meganav[data-menu-handle="${handle}"]`);
            if (menu) {
                // Optional: close other open meganavs first
                document.querySelectorAll('.meganav.active').forEach(active => {
                    if (active !== menu) active.classList.remove('active');
                });
                menu.classList.toggle("active");
            }
        });
    });
}
// Product video lightbox
document.body.addEventListener("click", async function (e) {
    const btn = e.target.closest(".mobile-media-carousel__play-icon");
    if (!btn) return;

    const mediaEl = btn.closest("[data-media-type='external_video']");
    const iframe = mediaEl?.querySelector("iframe");

    if (!mediaEl || !iframe) {
        console.warn("External video or iframe not found.");
        return;
    }

    const { PhotoSwipeLightbox, PhotoSwipe } = await import(flu.chunks.photoswipe);

    const iframeHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        padding: 5vw;
        box-sizing: border-box;
      ">
        <div style="
          width: 100%;
          max-width: 960px;
          aspect-ratio: 16 / 9;
        ">
          <iframe 
            src="${iframe.src}"
            style="
              width: 100%;
              height: 100%;
              border: none;
              display: block;
            "
            allowfullscreen
          ></iframe>
        </div>
      </div>
    `;

    const lightbox = new PhotoSwipeLightbox({
        dataSource: [{ html: iframeHTML }],
        pswpModule: PhotoSwipe,
        mainClass: "pswp--product-lightbox",
        closeSVG: window.theme?.icons?.close || "",
        arrowPrev: false,
        arrowNext: false,
        zoom: false,
        counter: false
    });

    lightbox.init();
    lightbox.loadAndOpen(0);
});






